export enum RoleCode {
  SUPER_ADMIN = "super_admin",
  ACCOUNTANT = "accountant",
  HR = "human_resource",
  EMPLOYEE = "employee",
  MARKETING = "marketing",
  PROJECT_ENGINEER = "project_engineer",
}

export const ROLE_HIERARCHY: Record<RoleCode, number> = {
  [RoleCode.SUPER_ADMIN]: 100,
  [RoleCode.HR]: 80,
  [RoleCode.ACCOUNTANT]: 60,
  [RoleCode.PROJECT_ENGINEER]: 60,
  [RoleCode.MARKETING]: 60,
  [RoleCode.EMPLOYEE]: 20,
};

/** Returns badge class for a role based on its hierarchy level. Higher level = more prominent. */
export const getRoleBadgeClass = (roleCode: string): string => {
  const level = ROLE_HIERARCHY[roleCode as RoleCode];
  if (level === undefined) return "bg-secondary-subtle text-secondary";
  if (level >= 90) return "bg-danger-subtle text-danger";
  if (level >= 70) return "bg-primary-subtle text-primary";
  if (level >= 50) return "bg-info-subtle text-info";
  return "bg-secondary-subtle text-secondary";
};
